import axios from "axios";
import { toast } from "react-toastify";
import { getAuthToken } from "./authUtils"; // 👈 adjust path as needed
import { clearAllSessionData } from "./sessionClearHelper";

const rawAxios = axios.create();

const apiClient = axios.create({
  withCredentials: true,
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("🚨 Intercepted error:", error);

    if (error.response?.status === 401) {
      console.log("401 detected. Running logout...");

      (async () => {
        const token = getAuthToken();

        if (token) {
          try {
            console.log("Calling logout API...");
            await rawAxios.post(
              `${process.env.REACT_APP_API_BASE_URL}/v1/admin/logout`,
              {},
              {
                headers: {
                  "Content-Type": "application/json",
                  "x-api-token": token,
                  "x-client-key": process.env.REACT_APP_API_CLIENT_KEY,
                  "x-app-client": "web",
                  "x-fcm-token": localStorage.getItem("fcmToken"),
                },
              }
            );
          } catch (logoutError) {
            console.warn("Logout API call failed:", logoutError);
          }
        }

        clearAllSessionData();
        localStorage.removeItem("token");
        localStorage.removeItem("fcmToken");

        toast.error("Your current session has invalid data. Please, login again.");
        window.location.href = "/login";
      })();
    }

    if (error.response?.status === 404) {
      // Handle 404 for order delete page navigating from browser back and forward
       const pattern = /^\/order\/([a-fA-F0-9]{24})\/([^/]+)$/;
       const urlPath = window.location.pathname;

       if (urlPath.match(pattern)) {
        window.location.href = "/404";
       }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
